export const MarketDataFeedsServiceUsersEditableSelector = 'serviceUsersEditable';
export const MarketDataFeedsEditableIdSelector = 'editable';
export const MarketDataFeedBundleEditableIdSelector = 'editableFeedBundle';
export const MarketDataFeedsNameSelector = 'name';
export const MarketDataFeedsServiceUserSelector = 'serviceUser';
export const MarketDataFeedsPlatformSelector = 'platform';
export const MarketDataFeedsCostAlaricProSelector = 'alaricProCost';
export const MarketDataFeedsCostAlaricNonProSelector = 'alaricNonProCost';
export const MarketDataFeedsCostIndividualProSelector = 'individualProCost';
export const MarketDataFeedsCostIndividualNonProSelector = 'individualNonProCost';
export const MarketDataFeedsExchangeSelector = 'exchange';
export const MarketDataFeedsDescriptionSelector = 'description';
export const MarketDataFeedsDateSelector = 'date';
export const MarketDataFeedsModifiedBySelector = 'modifiedBy';
export const MarketDataFeedBundlesRowIdSeparator = '|';
export const MarketDataFeedsOneFeedSelector = 'MarketDataFeedsOneFeed';
export const MarketDataFeedsCurrencySelector = 'currency';

export const AddNewFeedNasdaqReportMapName = 'Nasdaq Report Map';
export const AddNewFeedProductCodeForProName = 'Product Code For Pro';
export const AddNewFeedProductCodeForNonProName = 'Product Code For Non Pro';
export const AddNewFeedReportTitleIdForProName = 'Prefix (Billing Location) for the Pro';
export const AddNewFeedReportTitleIdForNonProName = 'Prefix (Billing Location) for the Non Pro';

export const REPORT_MAP_KEY_MAX_LENGTH = 32;
